import { Component, Input, ViewContainerRef, TemplateRef } from '@angular/core';
import { Sales, SaleProducts } from '../../models/sales/sales.model';
import { CategoryService } from '../../services/category/category.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { UtilitiesService } from '../../services/shared/utilities.service';
import { SaleCategories } from '../../models/sales/sales.model';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Payment } from '../../models/payment/payment-model';
import { PaymentService } from '../../services/payment/payment.service';
import { RolePermissionService } from '../../services/role/role-permission.service';
import { Router } from '@angular/router';
@Component({
    selector: 'app-category-sales-list',
    templateUrl: './category-sales-list.component.html',
    styleUrls: ['./category-sales-list.component.css']
})
/** category-sales-list component*/
export class CategorySalesListComponent {
  //Filter items from grid
  filteredItems: any[];
  saleList: Sales[];
  public sales = new Sales();
  saletype: number;
  plateform: number;
  isActive: string;
  searchKeyword: string;
  public rowsOnPage: number;
  public arrRowsPerPage: number[];
  saleCategoryList: SaleCategories[] = [];
  saleProductList: SaleProducts[] = [];
 public paymentMethod= new  Payment();
  modalRef: BsModalRef;
  config = {
    animated: true
  };
  public isDeleteAllowed: boolean = false;
  public isEditAllowed: boolean = false;
  public isCreateAllowed: boolean = false;
    /** category-sales-list ctor */
  constructor(private paymentService: PaymentService, private modalService: BsModalService, public toastr: ToastsManager, vcr: ViewContainerRef, private readonly categoryService: CategoryService, private readonly utilitiesService: UtilitiesService,
   private readonly router: Router, private readonly rolePermissionService: RolePermissionService) {
    this.rolePermissionService.GetRolePermissions("categorysale").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });

          var deletePermission = data.filter(function (element) {
            return (element.action == "delete");
          });

          var edit = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0)
            this.isCreateAllowed = true;

          if (edit.length > 0)
            this.isEditAllowed = true;

          if (deletePermission.length > 0)
            this.isDeleteAllowed = true;

          this.toastr.setRootViewContainerRef(vcr);
          this.GetRowsPerPageList();
          this.CategorySaleList();

          this.saletype = 0;
          this.plateform = -1;
          this.isActive = "";
          this.searchKeyword = "";
        }
        else {
          this.router.navigate(["/"]);
        }
      }
    )

  }

  CategorySaleList() {
    this.categoryService.GetSales().subscribe(
      data => {
        this.saleList = data;
        this.filteredItems = data;
      });
  }
  UpdateCategoryLevelSale() {


  }
  // Populate the row per page list
  GetRowsPerPageList() {
    this.arrRowsPerPage = this.utilitiesService.GetRowsPerPageList();
    this.rowsOnPage = this.arrRowsPerPage[0];
  }
  // Search the Grid
  OnFilterChange() {
    this.filteredItems = this.saleList;

    if (this.isActive == "true") {
      this.filteredItems = this.filteredItems.filter(s => s.isActive == true);

    } else if (this.isActive == "false") {
      this.filteredItems = this.filteredItems.filter(s => s.isActive == false);
    }
    if (this.saletype > 0) {
      this.filteredItems = this.filteredItems.filter(s => s.saleTypeID == this.saletype);
    }
    if (this.plateform !=-1) {
      this.filteredItems = this.filteredItems.filter(s => s.domainType == this.plateform);
    }    
    if (this.searchKeyword != "") {
      this.filteredItems = this.utilitiesService.GetSearchedResult(this.filteredItems, this.searchKeyword);
    }
  }

 
  formatDate(date: string): string {
    let newDate: any = date.split('-');
    let days: number = parseInt(newDate[2]) + 1;
    let months: number = parseInt(newDate[1]);
    let year: number = parseInt(newDate[0]);
    return months + "/" + days + "/" + year;
  }
  getsaleById(id: string) {
    this.categoryService.GetSaleById(id).subscribe(
      data => {
        this.sales = data;
        
        this.sales.startDate = this.formatDate(this.sales.startDate);
        this.sales.endDate = this.formatDate(this.sales.endDate);
        if (this.sales.saleTypeID == 1) {
          this.saleProductList = [];
          this.categoryService.GetSaleProductsById(this.sales.saleID).subscribe(
            data => {
              this.saleProductList = data;
            })
        }
        if (this.sales.saleTypeID == 2) {
          this.saleCategoryList = [];
          this.categoryService.GetSaleCategoriesById(this.sales.saleID).subscribe(
            data => {
              this.saleCategoryList = data;
            })
        }
        if (this.sales.saleTypeID == 3) {
          this.paymentService.PaymentMethodById(this.sales.paymentMethodID).subscribe(
            data => {
              this.paymentMethod = data;
            }
          )
        }

      }
    )
  }

  openModal(template: TemplateRef<any>, id: string) {
    this.getsaleById(id);
    this.modalRef = this.modalService.show(template, this.config);
  }
  confirm(): void {
    this.modalRef.hide();
  }

  decline(): void {
    this.modalRef.hide();
  }
  //onChange(id: string) {
  //  var title = "";
  // this.categoryService.UpdateSaleStatus(id).subscribe(     
  //    data => {
  //      if (data) {
  //        this.toastr.success(title + ' updated successfully.', 'Success');
  //      } else {
  //        this.toastr.error(title+ ' Not Updated.', 'Oops!');
  //      }
  //    }
  //  );

  //}
  ChangeStatus(id) {
    this.categoryService.ChangeStatus(id).subscribe(
      data => {
        if (data) {
          this.toastr.success('Sale Updated successfully.', 'Success');
          setTimeout(() => {
            this.CategorySaleList();
          }, 1000);
        } else {
          this.toastr.error('Sale Not Updated.', 'Oops!');
       }
        });
    
  }
}



// WEBPACK FOOTER //
// ./src/app/category-components/category-sales-list/category-sales-list.component.ts